/**
 * Option interface for SelectControl
 */
export interface SelectOption {
	label: string;
	value: string | number;
	disabled?: boolean;
}

/**
 * SelectControl component props
 */
export interface SelectControlProps {
	/** Current value(s) of the select control */
	value: string | number | ( string | number )[];
	/** Callback function when value changes */
	onChange: ( value: string | number | ( string | number )[] ) => void;
	/** Label for the select control */
	label: string;
	/** Help text displayed below the control */
	help?: string;
	/** Array of options to display */
	options: SelectOption[];
	/** Placeholder text when no option is selected */
	placeholder?: string;
	/** Whether to allow multiple selections */
	multiple?: boolean;
	/** Whether the control is disabled */
	disabled?: boolean;
	/** Additional CSS class names */
	className?: string;
	/** Whether the dropdown is searchable */
	searchable?: boolean;
	/** Custom styles for the control */
	style?: React.CSSProperties;
}

/**
 * Enums for common use cases
 */
export enum SelectSize {
	SMALL = 'small',
	MEDIUM = 'medium',
	LARGE = 'large',
}

export enum SelectVariant {
	DEFAULT = 'default',
	OUTLINED = 'outlined',
	FILLED = 'filled',
}
